<script lang="ts" setup>
import FlatIconBtn from '@/vue/molecules/flat-icon-btn.vue';

defineProps<{
  name: string;
  isSelected?: boolean;
  enableRemove?: boolean;
}>();

defineEmits<{
  remove: [];
}>();
</script>
<template>
  <div class="feeling-chip" :class="{'feeling-chip--is-selected': isSelected, 'feeling-chip--disable-remove': !enableRemove}">
    <span class="chip-name">
      {{ name }}
    </span>

    <flat-icon-btn
      v-if="enableRemove"
      icon="x-close.svg"
      class="remove-btn"
      :label="$t('input_your_feelings_remove', {feeling: name})"
      @click="$emit('remove')"
    />
  </div>
</template>
<style lang="scss" scoped>
.feeling-chip {
  @include font-body-sm-bold;
  color: var(--Neutral-UI-neutral-ui-80);
  background-color: var(--Neutral-UI-neutral-ui-10);
  border-radius: var(--button-border-radius);
  display: flex;
  gap: var(--Spacing-spacing-1);
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 var(--Spacing-spacing-1) 0 var(--Spacing-spacing-3);
  height: 30px;
  min-width: 65px;

  @include screen-lg {
    height: 40px;
    gap: var(--Spacing-spacing-2);
    padding: 0 var(--Spacing-spacing-2) 0 var(--Spacing-spacing-3);
  }

  &--is-selected {
    color: var(--Neutral-UI-neutral-ui-10);
    background-color: var(--Neutral-UI-neutral-ui-80);
  }

  &--disable-remove {
    padding: 0 var(--Spacing-spacing-3);
    justify-content: center;
  }

  .chip-name {
    @include font-body-sm-bold;
    display: flex;
    align-items: center;
    line-height: 1;
  }
}

.remove-btn {
  flex-shrink: 0;
  width: 24px;
  height: 24px;

  @include screen-lg {
    width: 32px;
    height: 32px;
  }

  :deep(.svg-wrapper) {
    width: 16px;
    height: 16px;

    @include screen-lg {
      width: 20px;
      height: 20px;
    }
  }

  &:focus-visible {
    outline-offset: -2px;
  }
}

</style>
